var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"panel-simple"},[_c('div',{staticClass:"header global-thead-dark title"},[_vm._v(" "+_vm._s(_vm.title)+" ")]),_c('div',{staticClass:"panel-row-without-selector pb-4 mb-5"},[_vm._t("content")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }